import Breadcrumb from "Components/Common/Breadcrumb";
import React from "react";
import { Container } from "reactstrap";
function DigitalCorrespondet() {
  document.title = "Ditobanx";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title="Digital Correspondet"
            breadcrumbItem="Digital Correspondet"
          />
          <h4>DigitalCorrespondet</h4>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default DigitalCorrespondet;
